<template>
  <NotificationTemplate
    :notification="notification"
    :showSubTitle="false"
    class="notification-calendar"
  >
    <template #pic>
      <div class="notification-calendar__icon">
        <icon
          data="@icon/calendar-full.svg"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>

    <template #title>
      <p class="notification-calendar__title">
        <span
          v-if="notification.initiator.fullName"
          class="notification-calendar__initiator"
        >
          @{{ notification.initiator.fullName }}
        </span>
        {{ actionText }}
      </p>
    </template>

    <template #content>
      <div
        v-if="notification.event"
        class="notification-calendar__content"
      >
        <CalendarEventSummary
          v-if="isUpdated && notification.oldEvent"
          :event="notification.oldEvent"
          muted
        />
        <icon
          v-if="isUpdated"
          data="@icon/arrow-to.svg"
          class="notification-calendar__arrow"
          color="var(--monochrome05to04)"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
        <CalendarEventSummary
          :event="notification.event"
          :removed="isDeleted"
        />
      </div>
    </template>
  </NotificationTemplate>
</template>

<script setup lang="ts">
import { computed } from "vue"

import CalendarEventSummary from "@/components/Notification/components/CalendarEventSummary.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationCalendar, NotificationType } from "@/models/Notification"

const props = defineProps<{
  notification: NotificationCalendar
}>()

const actionText = computed(() => {
  switch (props.notification.type) {
    case NotificationType.CALENDAR_EVENT_UPDATED:
      return "updated your Time Off:"
    case NotificationType.CALENDAR_EVENT_DELETED:
      return "removed your Time Off:"
    default:
      return "scheduled a Time Off for you:"
  }
})

const isUpdated = computed(
  () =>
    props.notification.type === NotificationType.CALENDAR_EVENT_UPDATED &&
    Boolean(props.notification.oldEvent)
)
const isDeleted = computed(
  () => props.notification.type === NotificationType.CALENDAR_EVENT_DELETED
)
</script>
